import React from 'react';
import { Card, Button, Space, Typography, Upload } from 'antd';
import { UploadOutlined, ReloadOutlined, FileTextOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function ImportConversationUploadCard({
  loading,
  fileName,
  fileSize,
  uploadedAt,
  onUpload,
  onReset,
}) {
  return (
    <Card bordered={false} style={{ borderRadius: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.03)' }}>
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <div>
          <div style={{ fontSize: '15px', fontWeight: 700, color: '#1a1a1a', marginBottom: 6 }}>
            Import file hội thoại / FAQ
          </div>
          <Text type="secondary">
            Chỉ hỗ trợ file .txt. File không cần khớp 100% mẫu, miễn hệ thống vẫn nhận ra được các cặp hỏi / đáp liên tiếp.
          </Text>
        </div>

        <Space>
          <Upload
            accept=".txt"
            showUploadList={false}
            beforeUpload={(file) => {
              onUpload(file);
              return false;
            }}
          >
            <Button type="primary" icon={<UploadOutlined />} loading={loading}>
              Chọn file .txt
            </Button>
          </Upload>
          <Button icon={<ReloadOutlined />} onClick={onReset} disabled={!fileName || loading}>
            Tải lại file
          </Button>
        </Space>

        {fileName ? (
          <div style={{ padding: '12px 14px', borderRadius: '10px', backgroundColor: '#f8fafc', border: '1px solid #e5e7eb' }}>
            <Space direction="vertical" size={4}>
              <Space>
                <FileTextOutlined style={{ color: '#2563eb' }} />
                <Text strong>{fileName}</Text>
              </Space>
              <Text type="secondary">Dung lượng: {fileSize || 0} bytes</Text>
              <Text type="secondary">Thời điểm upload: {uploadedAt || '-'}</Text>
            </Space>
          </div>
        ) : null}
      </Space>
    </Card>
  );
}
